import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/calculators", label: "Calculators" },
  { to: "/insights", label: "Insights" },
  { to: "/team", label: "Team" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logo.webp" alt="Manigriv Financial Services" className="h-11 md:h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-anim text-sm font-medium ${isActive ? "text-midnight" : "text-midnight/70 hover:text-midnight"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <button data-testid="nav-portal" onClick={() => nav(user.role === "client" ? "/portal" : "/admin")} className="btn-outline-ink text-sm">
                {user.role === "client" ? "Portal" : "Dashboard"}
              </button>
              <button data-testid="nav-logout" onClick={logout} className="text-sm text-midnight/70 hover:text-midnight">Logout</button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login" className="btn-outline-ink text-sm">Login</Link>
          )}
          <Link to="/book" data-testid="nav-book" className="btn-gold text-sm">Book Consultation</Link>
        </div>

        <button data-testid="nav-menu" className="lg:hidden text-midnight" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-midnight/10 bg-bone">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className="text-midnight/80 font-medium">{n.label}</NavLink>
            ))}
            <div className="pt-4 flex gap-3">
              {user ? (
                <button onClick={() => { setOpen(false); nav(user.role === "client" ? "/portal" : "/admin"); }} className="btn-outline-ink text-sm flex-1">
                  {user.role === "client" ? "Portal" : "Dashboard"}
                </button>
              ) : (
                <Link to="/login" onClick={() => setOpen(false)} className="btn-outline-ink text-sm flex-1 text-center">Login</Link>
              )}
              <Link to="/book" onClick={() => setOpen(false)} className="btn-gold text-sm flex-1 text-center">Book</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export function WhatsAppFloat() {
  const msg = encodeURIComponent("Hello Manigriv, I'd like to know more about your services.");
  return (
    <a
      href={`https://wa.me/917300838191?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl animate-pulse-gold"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
}
